import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b57d3a0a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "normalize.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/styles/main.sass?vue&type=style&index=1&prod&lang=sass&external"
import style2 from "./App.vue?vue&type=style&index=2&id=b57d3a0a&prod&lang=sass"
import style3 from "./App.vue?vue&type=style&index=3&id=b57d3a0a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57d3a0a",
  null
  
)

export default component.exports